import { Card, Typography, Space, Image } from 'antd';
import { useNavigate } from 'react-router-dom';
import { Product } from '../../types/product';
import { QualityScoreBadge } from '../common/QualityScoreBadge';
import { ProviderTag } from '../common/ProviderTag';

const { Text, Title } = Typography;

interface ProductCardProps {
  product: Product;
}

export function ProductCard({ product }: ProductCardProps) {
  const navigate = useNavigate();

  // Get primary image from elements or product.image object
  const primaryImage = product.elements?.find((el) => el.type === 'Image');
  let imageUrl: string = '/placeholder-product.png';
  if (primaryImage?.url) {
    imageUrl = primaryImage.url;
  } else if (product.image) {
    // Handle both string and object formats
    if (typeof product.image === 'string') {
      imageUrl = product.image;
    } else if (typeof product.image === 'object') {
      const img = product.image as { original?: string; '500'?: string; '300'?: string };
      imageUrl = img.original || img['500'] || img['300'] || '/placeholder-product.png';
    }
  }

  const productName =
    product.description ||
    product.mfgpartno ||
    product.productid;

  const handleClick = () => {
    navigate(`/products/${encodeURIComponent(product.productid)}`, {
      state: { product },
    });
  };

  return (
    <Card
      hoverable
      onClick={handleClick}
      cover={
        <div
          style={{
            height: 200,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: '#f5f5f5',
            overflow: 'hidden',
          }}
        >
          <Image
            src={imageUrl}
            alt={productName}
            style={{ maxHeight: 180, maxWidth: '100%', objectFit: 'contain' }}
            preview={false}
            fallback="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100' viewBox='0 0 100 100'%3E%3Crect fill='%23f0f0f0' width='100' height='100'/%3E%3Ctext x='50' y='50' font-family='Arial' font-size='12' fill='%23999' text-anchor='middle' dy='.3em'%3ENo Image%3C/text%3E%3C/svg%3E"
          />
        </div>
      }
      styles={{
        body: { padding: 16 },
      }}
    >
      <Space direction="vertical" size="small" style={{ width: '100%' }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
          }}
        >
          <ProviderTag provider={product.data_source} />
          <QualityScoreBadge score={product.quality_score} />
        </div>

        <Title
          level={5}
          ellipsis={{ rows: 2 }}
          style={{ margin: 0, minHeight: 44 }}
        >
          {productName}
        </Title>

        {product.manufacturer?.name && (
          <Text type="secondary" ellipsis>
            {product.manufacturer.name}
          </Text>
        )}

        {product.mfgpartno && (
          <Text type="secondary" style={{ fontSize: 12 }}>
            MPN: {product.mfgpartno}
          </Text>
        )}
      </Space>
    </Card>
  );
}
